/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Dialog_ProcessingInputs */

const en_directory_ads_dialog_processing = /** @type {(inputs: Directory_Ads_Dialog_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting…`)
};

const zh_directory_ads_dialog_processing = /** @type {(inputs: Directory_Ads_Dialog_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳转中…`)
};

/**
* | output |
* | --- |
* | "Redirecting…" |
*
* @param {Directory_Ads_Dialog_ProcessingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_dialog_processing = /** @type {((inputs?: Directory_Ads_Dialog_ProcessingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Dialog_ProcessingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_dialog_processing(inputs)
	return zh_directory_ads_dialog_processing(inputs)
});
export { directory_ads_dialog_processing as "directory.ads.dialog_processing" }